import { forwardRef } from 'react'
import HeroIcon, { HeroIconProps } from '../HeroIcon'

export default forwardRef<SVGSVGElement, HeroIconProps>((props, ref) => {
  const { type = 'solid', ...rest } = props
  return <HeroIcon ref={ref} Component={Component} {...rest} />
})

const Component = forwardRef<SVGSVGElement, any>((props, ref) => {
  return (
    <svg ref={ref} width="68" height="60" viewBox="0 0 68 60" fill="none" {...props}>
      <g clipPath="url(#clip0_8773_35341)">
        <path
          opacity="0.4"
          d="M22.8322 7.5C21.845 7.5 20.8982 7.89509 20.2002 8.59835C19.5021 9.30161 19.11 10.2554 19.11 11.25C19.11 12.2446 19.5021 13.1984 20.2002 13.9017C20.8982 14.6049 21.845 15 22.8322 15C23.8194 15 24.7661 14.6049 25.4642 13.9017C26.1623 13.1984 26.5544 12.2446 26.5544 11.25C26.5544 10.2554 26.1623 9.30161 25.4642 8.59835C24.7661 7.89509 23.8194 7.5 22.8322 7.5ZM60.0544 48.75C64.1605 48.75 67.4989 45.3867 67.4989 41.25V22.5H11.6655V41.25C11.6655 45.3867 15.0039 48.75 19.11 48.75H60.0544Z"
          fill="#3C4BD3"
        />
        <path
          d="M19.1101 0C15.0041 0 11.6657 3.36328 11.6657 7.5V22.5H67.499V7.5C67.499 3.36328 64.1607 0 60.0546 0H19.1101ZM22.8324 15C21.8452 15 20.8984 14.6049 20.2003 13.9017C19.5023 13.1984 19.1101 12.2446 19.1101 11.25C19.1101 10.2554 19.5023 9.30161 20.2003 8.59835C20.8984 7.89509 21.8452 7.5 22.8324 7.5C23.8196 7.5 24.7663 7.89509 25.4644 8.59835C26.1624 9.30161 26.5546 10.2554 26.5546 11.25C26.5546 12.2446 26.1624 13.1984 25.4644 13.9017C24.7663 14.6049 23.8196 15 22.8324 15ZM30.2768 11.25C30.2768 9.69141 31.5214 8.4375 33.0685 8.4375H57.2629C58.81 8.4375 60.0546 9.69141 60.0546 11.25C60.0546 12.8086 58.81 14.0625 57.2629 14.0625H33.0685C31.5214 14.0625 30.2768 12.8086 30.2768 11.25ZM6.08236 14.0625C6.08236 12.5039 4.83774 11.25 3.29069 11.25C1.74364 11.25 0.499023 12.5039 0.499023 14.0625V44.0625C0.499023 52.8633 7.58288 60 16.3185 60H53.5407C55.0877 60 56.3324 58.7461 56.3324 57.1875C56.3324 55.6289 55.0877 54.375 53.5407 54.375H16.3185C10.6653 54.375 6.08236 49.7578 6.08236 44.0625V14.0625Z"
          fill="#3C4BD3"
        />
      </g>
      <defs>
        <clipPath id="clip0_8773_35341">
          <rect width="67" height="60" fill="white" transform="translate(0.499023)" />
        </clipPath>
      </defs>
    </svg>
  )
})
